<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<div style="position: fixed;bottom: 5px;right: 50px;width: 50px;height: 50px;background-color: red;color: #FFF;z-index: 2;line-height: 50px;text-align: center;"
			@click="fha">
			返回
		</div>
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/zjzk.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/zjzk_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>展会</span><span style="color:#D7230C;">会议</span></div>
							<div class="sm_pub">带你领略展会风采</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">展会会议</div>
				</div>
				<div @click="wybms"
					style="width: 100px;height: 30px;background: red;float: left;color: #FFF;line-height: 30px;text-align: center;border-radius: 10px;margin-top: 5px;margin-left: 15px;">
					我要报名
				</div>
				<div @click="ckmd"
					style="width: 120px;height: 30px;background: red;float: left;color: #FFF;line-height: 30px;text-align: center;border-radius: 10px;margin-top: 5px;margin-left: 15px;">
					查看报名名单
				</div>
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom">
				<div class="top_bottom_T">
					<div class="dtiail_warp">
						<div class="dtiail_title">{{title}}</div>
						<!-- 上传者信息 -->
						<div style="text-align: center;">
							<span>上传日期：{{getLocalTime(contents.create_time)}}</span>
							<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上传者：{{`${contents.uid}`.substring(0,1)}}&nbsp; *&nbsp;*
								&nbsp;{{`${contents.username}`.substring(3,4)}}</span>
							<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;阅读数：{{contents.view}}</span>
						</div>
						<!-- 内容渲染 -->
						<div class="cont_dtiail" v-html="contents.content">
						</div>
					</div>
					<div style="width: 95%;margin: 0 auto;height: 100px;margin-top: 20px;">
						<!-- <Xguanyuedu></Xguanyuedu> -->
						<!-- 打赏分享 -->
						<!-- <tabmore :price="0" nologin_type="xptj" name="新品推荐" :tid="$route.query.id"></tabmore> -->
						<div @click="sca"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 35%;">
							<img class="scname" src="../../../imges/dsdsdsds/shoucang1.png" style="width: 100%;height: 50px;" alt="">
							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
								收藏
							</div>
						</div>
						<div  @click="getShareInfo"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;">
							<img class="scname" src="../../../imges/dsdsdsds/weixin1.png" style="width: 100%;height: 50px;" alt="">
							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
								微信
							</div>
						</div>
						<div @click="fxkj"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;">
							<img class="scname" src="../../../imges/dsdsdsds/qqkongjian1.png" style="width: 100%;height: 50px;" alt="">
							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
								空间
							</div>
						</div>
						<div @click="das"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;border-radius: 50%;">
							<img class="scname" src="../../../imges/dsdsdsds/dashang1.png"
								style="width: 100%;height: 50px;" alt="">
								<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
									打赏
								</div>
						</div>
					</div>
					<div style="width: 95%;margin: 0 auto;height: 140px;border-top: 1px dashed #ddd;">

					</div>
				</div>
				<!-- 侧边栏 -->
				<div class="top_bottom_B">
					<rightlist></rightlist>
				</div>
			</div>
		</div>
		<el-dialog title="报名名单" :visible.sync="dialogVisible" width="80%" :before-close="handleClose"
			style="overflow-x: scroll;">
			<el-button  @click="ffcka" type="primary" size="small" style="position: absolute;right: 70px;top: 50px;">
				付费查看
			</el-button>
		<!-- 	<el-button  @click="ffckas" type="primary" size="small" style="position: absolute;right: 155px;top: 50px;">
				刷新
			</el-button> -->
			<download-excel class="export-excel-wrapper" :data="json_data" :fields="json_fields" name="报名信息表.xls">
				<!-- 上面可以自定义自己的样式，还可以引用其他组件button -->
				<el-button  type="primary" size="small" style="position: absolute;right: 20px;top: 50px;">
					<i class="el-icon-download"></i>
				</el-button>
			</download-excel>
			<div style="width: 100%;height: 30px;text-align: center;background-color: antiquewhite;">
				<div style="width: 30%;height: 30px;line-height: 30px;float: left;" class="nssbm">
					单位
				</div>
				<div style="width: 10%;height: 30px;line-height: 30px;float: left;" class="nssbm">
					职务
				</div>
				<div style="width: 15%;height: 30px;line-height: 30px;float: left;" class="nssbm">
					姓名
				</div>
				<div style="width: 15%;height: 30px;line-height: 30px;float: left;" class="nssbm">
					手机
				</div>
				<div style="width: 15%;height: 30px;line-height: 30px;float: left;" class="nssbm">
					电话
				</div>
				<div style="width: 15%;height: 30px;line-height: 30px;float: left;" class="nssbm">
					邮箱
				</div>
				
			</div>
			<div style="width: 100%;height: 30px;text-align: center;border-bottom: 1px solid #ededed;box-sizing: border-box;"
				v-for="(item,index) in jobs" :key="index">
				<div style="width: 30%;height: 30px;line-height: 30px;float: left;" class="nssbm">
					{{item.dbname}}
				</div>
				<div style="width: 10%;height: 30px;line-height: 30px;float: left;" class="nssbm">
					{{item.zw}}
				</div>
				<div style="width: 15%;height: 30px;line-height: 30px;float: left;">
					{{item.name}}
				</div>
				<div style="width: 15%;height: 30px;line-height: 30px;float: left;" class="nssbm">
					{{item.phone}}
				</div>
				<div style="width: 15%;height: 30px;line-height: 30px;float: left;" class="nssbm">
					{{item.tel}}
				</div>
				<div style="width: 15%;height: 30px;line-height: 30px;float: left;" class="nssbm">
					{{item.email}}
				</div>
				
			</div>
			<!-- <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span> -->
		</el-dialog>
		<div v-show="wybm"
			style="width: 400px;z-index: 999;position: fixed;top: 15%;left: 35%;background-color: #FFF;box-sizing: border-box;padding-left: 20px;padding-right: 20px;border: 4px solid #6e6e6e;box-shadow: x-shadow 0 10px 10px rgba(0, 0, 0, .2);height: 520px;">
			<div style="width: 100%;height: 50px;">
				<div style="line-height: 50px;height: 50px;float: left;">
					报名通道
				</div>
				<div style="width: 30px;height: 50px;float: right;font-size: 26px;font-weight: 600;line-height: 50px;"
					@click="wybm = false">
					X
				</div>
			</div>
			<el-form ref="form" :model="form" label-width="80px" style="margin-top: 30px;">
				<el-form-item label="联系人">
					<el-input v-model="form.Name"></el-input>
				</el-form-item>
				<el-form-item label="单位名称">
					<el-input v-model="form.Dbname"></el-input>
				</el-form-item>
				<el-form-item label="职务">
					<el-input v-model="form.Zw"></el-input>
				</el-form-item>
				<el-form-item label="电话">
					<el-input v-model="form.Phone"></el-input>
				</el-form-item>
				<el-form-item label="座机">
					<el-input v-model="form.tel"></el-input>
				</el-form-item>
				<el-form-item label="邮箱">
					<el-input v-model="form.Zhanshi"></el-input>
				</el-form-item>
				<!-- 	<el-form-item label="展会类型">
					<el-select v-model="form.desc" placeholder="请选择展会类型">
						<el-option label="行业会议" value="1"></el-option>
						<el-option label="行业展会" value="2"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item>
					<el-button type="primary" @click="onSubmit(form)">立即创建</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<myfooter></myfooter>
		<qbes ref="dashang"></qbes>
		<dashang ref="child" :dsje="dsje"></dashang>
		<div class="popContainer" v-show="isShowQR" @click="gbgb">
			<vue-qr style="display: inline-block;
		position: absolute;
		top: 40%;
		left: 40%;" :logoSrc="imageUrl" :text="Text" :size="200"></vue-qr>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	import vueQr from 'vue-qr'
	export default {
		data() {
			return {
				imageUrl: 'https://img1.baidu.com/it/u=3311948344,2093308219&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500',
				Text: '',
				isShowQR: false, //二维码显示
				letData: true,
				options: [],
				searchData: {
					type: '职位',
					keyword: '' //搜索框查询关键字
				},
				dialogVisible: false,
				value: '',
				id: this.$route.query.id,
				title: this.$route.query.title,
				mid: this.$route.query.mid,
				contents: '',
				wybm: false,
				jobs: '',
				json_fields: {
					"单位": "dbname", //常规字段
					"职务": "dbname", //支持嵌套属性
					"姓名": "name",
					"手机": "phone",
					"电话": "tel",
					"邮箱": "email",
				},
				json_data:[],
				dsje: [{
					tid: this.$route.query.id,
					nologin_type: 'zhhy',
					name: '展会会议打赏',
					price: 0,
				}],
				form: {
					Name: '',
					Dbname: '',
					Zw: '',
					Phone: '',
					tel: '',
					Zhanshi: '',
					desc: ''
				}
			}
		},
		methods: {
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleDateString().replace(/:\d{1,2}$/, ' ');
			},
			wybms() {
				this.wybm = true
			},
			gbgb() {
				this.isShowQR = false
				// $('#qrCodeUrl').html = ''
			},
			das() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					this.$refs.child.isShowZF = true //修改子组件data
				} else {
					this.$router.replace('/login')
				}
			},
			fxkj() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					const share = {
						title: this.contents.title,
						desc: "海工人|船海智造360°综合服务平台",
						image_url: [this.contents.picture],
						share_url: "https://www.shipoe360.com/#" + this.$route.path + '?id=' + this.id  
					};
					//跳转地址
					location.replace(
						"https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
						encodeURIComponent(share.share_url) +
						"&title=" +
						share.title +
						"&pics=" +
						share.image_url.join("|") +
						"&summary=" +
						share.desc
					);
				} else {
					this.$router.replace('/login')
				}
			},
			getShareInfo() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					if (this.letData) {
						let myhref = window.location.href
						console.log(myhref)
						this.Text = myhref
						this.isShowQR = true
						this.letData = false
					} else {
						this.isShowQR = true
					}
				} else {
					this.$router.replace('/login')
				}
			},
			fha() {
				console.log('返回上一层')
				this.$router.go(-1); //返回上一层
			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			ffcka(){
				this.$refs.dashang.DS_ck(100, '展会付费查看', 'zhffck', this.$route.query.id)
				this.sbb()
			},
			ckmd() {
				this.sbbb()
				// console.log(this.json_data)
			},
			async onSubmit(id) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (id.Name == '') {
					alert('请填写联系人')
					return
				} else if (id.Dbname == '') {
					alert('请填写单位名称')
					return
				} else if (id.Zw == '') {
					alert('请填写职务')
					return
				} else if (!/^(13[0-9]|14[01,4-9]|15[0-3,5-9]|16[5-7]|17[0135678]|18[0-9]|19[189])\d{8}$/.test(id
						.Phone)) {
					alert('请填写正确的电话')
					// if () {
					// 	callback(new Error('请输入标准的手机号码'))
					// } else {
					// 	return
					// }
					return
				} else if (id.tel == '') {
					alert('请填写座机')
					return
				} else if (id.Zhanshi == '') {
					alert('请填写邮箱')
					return
				}
				if (this.mid == 1) {
					let res = await http.post('api/picture/bmhy', {
						uid: loginInfo.id,
						name: id.Name,
						dbname: id.Dbname,
						zw: id.Zw,
						tel: id.tel,
						phone: id.Phone,
						email: this.form.Zhanshi,
						zhanshi: '1',
						fid: this.contents.id
					})
					// console.log(this.form);
					if (res.data.code == '200') {
						alert('成功')
						this.form.Name = ''
						this.form.Dbname = ''
						this.form.Zw = ''
						this.form.Phone = ''
						this.form.Zhanshi = ''
						this.form.desc = ''
						this.wybm = false
						this.sbb()
					} else {
						alert('未成功')
					}
				} else if (this.mid == 2) {
					let res = await http.post('api/picture/bmhy', {
						uid: loginInfo.id,
						name: id.Name,
						dbname: id.Dbname,
						zw: id.Zw,
						phone: id.Phone,
						email: this.form.Zhanshi,
						zhanshi: '2',
						fid: this.contents.id
					})
					if (res.data.code == '200') {
						alert('成功')
						this.form.Name = ''
						this.form.Dbname = ''
						this.form.Zw = ''
						this.form.Phone = ''
						this.form.Zhanshi = ''
						this.form.desc = ''
						this.wybm = false
						this.sbb()
					} else {
						alert('未成功')
					}
				}
			},
			ffckas(){
				location.reload();
			},
			async sbbb() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if(!loginInfo){
					this.$router.push('/login')
					return
				}
				let res = await http.get('index.php/bscard/wxapp.Sorts')
				this.options = res.data.data
				console.log(this.mid)
				if (this.mid == 1) {
					let res1 = await http.post('api/picture/hyhx_details', {
						id: this.id,
						uid:loginInfo.id
					})
					this.contents = res1.data.data
					console.log(res1)
					if(this.contents.ff_status==1){
						this.jobs = this.contents.job
						this.jobs.forEach(item=>{
							this.json_data.push(item)
						})
					} else {
						this.jobs = this.contents.job
						this.jobs.forEach(item=>{
							this.json_data.push(item)
						})
					}
				} else if (this.mid == 2) {
					let res2 = await http.post('api/picture/hyzh_details', {
						id: this.id,
						uid:loginInfo.id
					})
					this.contents = res2.data.data
					console.log(res2)
					if(this.contents.ff_status==1){
						this.jobs = this.contents.job
						this.jobs.forEach(item=>{
							this.json_data.push(item)
						})
					} else {
						this.jobs = this.contents.job
						this.jobs.forEach(item=>{
							this.json_data.push(item)
						})
					}
				}
				this.dialogVisible = true
			},
			async sbb() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				
				let res = await http.get('index.php/bscard/wxapp.Sorts')
				this.options = res.data.data
				console.log(this.mid)
				if (this.mid == 1) {
					let res1 = await http.post('api/picture/hyhx_details', {
						id: this.id,
					})
					this.contents = res1.data.data
					console.log(res1)
				} else if (this.mid == 2) {
					let res2 = await http.post('api/picture/hyzh_details', {
						id: this.id,
					})
					this.contents = res2.data.data
					console.log(res2)
				}
			},
			async sca() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/personal_collection', {
					uid: loginInfo.id,
					title: this.contents.title,
					picture: this.contents.picture,
					pc_link: this.$route.path + '?id=' + this.id + '&title=' + this.title,
					url_link: this.$route.path + '?id=' + this.id + '&title=' + this.title,
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '收藏成功',
						type: 'success'
					});
				} else {
					this.$notify({
						title: '失败',
						message: res.data.msg,
						type: 'error'
					});
				}
			},
		},
		async mounted() {
			this.sbb()
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),
			//测标签
			rightlist: resolve => require(['@/components/dpubtop/rightList.vue'], resolve),
			//广澳
			PCguangao: resolve => require(['@/components/dpubtop/PCguangao.vue'], resolve),
			//相关阅读
			Xguanyuedu: resolve => require(['@/components/dpubtop/xgyd.vue'], resolve),
			dashang: resolve => require(['@/components/dashang/dashang.vue'], resolve),
			qbes: resolve => require(['@/components/dashang/dashangs.vue'], resolve),
			vueQr,
		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.nssbm {
		word-wrap: break-word;
		/*强制换行*/
		overflow: hidden;
		/*超出隐藏*/
		text-overflow: ellipsis;
		/*隐藏后添加省略号*/
		white-space: nowrap;
		/*强制不换行*/

	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}


	/* 头部结束 */
	.top_bottom {
		width: 100%;
		clear: both;
		overflow: hidden;
		height: 100%;
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}

	.top_bottom_T {
		width: 75%;
		float: left;
	}

	.top_bottom_B {
		width: 25%;
		float: left;
	}

	.dtiail_warp {
		width: 95%;
		margin: 0 auto;
	}

	.dtiail_title {
		margin-top: 40px;
		margin-bottom: 16px;
		text-align: center;
		font-size: 22px;
		color: #c00e0e;
	}

	.cont_dtiail>>>p>>>img {
		width: auto;
		height: 100%;
	}

	.cont_dtiail {
		overflow: hidden;
		margin-top: 20px;
		min-height: 300px;
	}
	
	/* 遮罩层 */
	.popContainer {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		background: rgba(0, 0, 0, 0.6);
	}
</style>
